import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { LeadCardHistoryItemData } from '@app/components/LeadCard/data';
import { formatLeadHistoryTimestamp } from '@app/components/LeadCard/ui/MessageHistory/lib';

import { useLeadCompletedTaskMessage } from '../hooks/useLeadCompletedTaskMessage';

import type { FC } from 'react';

import './LeadCompletedTaskMessage.scss';

interface LeadCompletedTaskMessageProps {
  item: LeadCardHistoryItemData;
}

export const LeadCompletedTaskMessage: FC<LeadCompletedTaskMessageProps> = ({
  item,
}) => {
  const { taskLine, openTask } = useLeadCompletedTaskMessage({
    taskId: item.ObjectId,
  });

  return (
    <div className="LeadCompletedTaskMessage" data-action-id={item.IdS ?? ''}>
      <span className="LeadCompletedTaskMessage__check">
        <FontAwesomeIcon icon={faCircleCheck} />
      </span>
      <div className="LeadCompletedTaskMessage__body">
        <div className="LeadCompletedTaskMessage__meta">
          <span className="LeadCompletedTaskMessage__timestamp">
            {formatLeadHistoryTimestamp(item.Timestamp)}
          </span>
          {item.ActionUser && (
            <span className="LeadCompletedTaskMessage__author">
              {item.ActionUser}
            </span>
          )}
        </div>
        {/* Тип и текст задачи приходят отдельным запросом: пока их нет
            (задача не загрузилась или удалена), строка не рисуется. */}
        {taskLine && (
          <button
            type="button"
            className="LeadCompletedTaskMessage__task"
            onClick={openTask}
          >
            {taskLine}
          </button>
        )}
      </div>
    </div>
  );
};
